import { parseRecordSafely } from 'utils/whiteboard/parseRecordSafely';
import { WhiteboardRecord } from 'utils/whiteboard/settings';

export const parseBoardState = (records: string[]) => {
  const result: WhiteboardRecord[] = [];
  for (const record of records) {
    const parsedRecord = parseRecordSafely(record);
    if (parsedRecord) {
      result.push(parsedRecord as WhiteboardRecord);
    }
  }

  return result;
};
